import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import * as firebase from "firebase/app"
import "firebase/auth"

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/chefSpecialMenu',
    name: 'ChefSpecialMenu',
    component: () => import(/* webpackChunkName: "chefSpecialMenu" */ '../views/chefSpecialMenu.vue'),
  },
  {
    path: '/appetizer',
    name: 'Appetizer',
    component: () => import(/* webpackChunkName: "appetizer" */ '../views/appetizer.vue')
  },
  {
    path: '/chicken',
    name: 'Chicken',
    component: () => import(/* webpackChunkName: "chicken" */ '../views/chicken.vue')
  },
  {
    path: '/dessert',
    name: 'Dessert',
    component: () => import(/* webpackChunkName: "dessert" */ '../views/dessert.vue')
  },
  {
    path: '/drinkSpecialMenu',
    name: 'DrinkSpecialMenu',
    component: () => import(/* webpackChunkName: "drinkSpecialMenu" */ '../views/drinkSpecialMenu.vue')
  },
  {
    path: '/duck',
    name: 'duck',
    component: () => import(/* webpackChunkName: "duck" */ '../views/duck.vue')
  },

  {
    path: '/fish',
    name: 'Fish',
    component: () => import(/* webpackChunkName: "fish" */ '../views/fish.vue')
  },
  {
    path: '/pork',
    name: 'Pork',
    component: () => import(/* webpackChunkName: "pork" */ '../views/pork.vue')
  },
  {
    path: '/salad',
    name: 'Salad',
    component: () => import(/* webpackChunkName: "salad" */ '../views/salad.vue')
  },
  {
    path: '/seafood',
    name: 'Seafood',
    component: () => import(/* webpackChunkName: "seafood" */ '../views/seafood.vue')
  },
  {
    path: '/side_dish',
    name: 'Side_dish',
    component: () => import(/* webpackChunkName: "side_dish" */ '../views/side_dish.vue')
  },
  {
    path: '/soup',
    name: 'Soup',
    component: () => import(/* webpackChunkName: "soup" */ '../views/soup.vue')
  },
  {
    path: '/tkSpecialMenu',
    name: 'TKSpecialMenu',
    component: () => import(/* webpackChunkName: "tkSpecialMenu" */ '../views/tkSpecialMenu.vue')
  },
  {
    path: '/vegetable',
    name: 'Vegetable',
    component: () => import(/* webpackChunkName: "vegetable" */ '../views/vegetable.vue')
  },
  {
    path: '/drink',
    name: 'Drink',
    component: () => import(/* webpackChunkName: "drink" */ '../views/drink.vue'),
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Admin/admin.vue'),
    meta: { admin: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Admin/login.vue'),
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  const admin = to.matched.some(record => record.meta.admin);

  const isAuthenticated = firebase.auth().currentUser;
  
  console.log("isauthenticated", isAuthenticated);

  if(admin){
    if(isAuthenticated != null){
      next();
    }else {
      next('/login');
    }
  }else if(isAuthenticated != null && to.path === '/login'){
    next('/admin');
  }else {
    next();
  }
  

});
export default router
